import { useState, useEffect, useRef } from "react";
import Pagination from "../../components/Pagination";
import styles from "../../styles/performance/Portfolio.module.css";
import classNames from "classnames/bind";
import aciData from "../../data/accident.json";
import AciCard from "../../components/AciCard";

const cx = classNames.bind(styles);

//업무실적
export default function Portfolio() {
  const aciList = aciData.cases;

  const [page, setPage] = useState(1);
  const itemsPerPage = 6;

  const totalPages = Math.ceil(aciList.length / itemsPerPage);

  const startIndex = (page - 1) * itemsPerPage;
  const currentData = aciList.slice(startIndex, startIndex + itemsPerPage);

  const topRef = useRef(null);
  const isFirstRender = useRef(true);
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(false);
    if (isFirstRender.current) {
      window.scrollTo({ top: 0, behavior: "auto" });
      isFirstRender.current = false;
      return;
    }

    const timer = setTimeout(() => {
      setShow(true);
      topRef.current?.scrollIntoView({ behavior: "auto" });
    }, 50);

    return () => clearTimeout(timer);
  }, [page]);

  return (
    <div>
      <div ref={topRef} className={cx("portfolioWrap")}>
        <div className={cx("title")}>
          <h4>업무실적</h4>
        </div>
        <div key={page} className={cx("portContentWrap")}>
          {currentData.map((item, index) => (
            <div
              key={`${page}-${index}`}
              className={cx("portCardWrap", "reveal", { show: show })}
            >
              <AciCard key={index} item={item} />
            </div>
          ))}
        </div>

        <Pagination
          page={page}
          totalPages={totalPages}
          onPageChange={setPage}
          pagesPerGroup={10}
        />
      </div>
    </div>
  );
}
